import ACTIONS from '../actions.js'

export function useAuthActions(dispatch) {
  return {
    setAuthType: value => dispatch({ type: ACTIONS.SET_AUTH_TYPE, value }),
    setSecretQuestions: value =>
      dispatch({ type: ACTIONS.SET_SECRET_QUESTIONS, value }),
    updateSecretQuestion: (questionKey, field, value) =>
      dispatch({
        type: ACTIONS.UPDATE_SECRET_QUESTION,
        payload: { questionKey, field, value },
      }),
  }
}

export default useAuthActions
